import script from "./CrudCatMaquinas.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudCatMaquinas.vue?vue&type=script&setup=true&lang=js"

import "./CrudCatMaquinas.vue?vue&type=style&index=0&id=712fcfde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712fcfde"]])

export default __exports__